import { mutationFor } from "@visioni/a3s-client-api/app";
import {
  clearAlarmOverrideEndpoint,
  setAlarmOverrideEndpoint,
  setAlarmSilenceEndpoint,
} from "../client-messages/alarms";

/**
 * React Query mutation factories for the alarm control write-side.
 * Paired with the Phase-1 view model and the Phase-2 `interpret` translator:
 *
 *   view + command → interpret(...) → MutationRequest → {one of these}
 */

export const setAlarmOverrideMutation = mutationFor(setAlarmOverrideEndpoint);
export const clearAlarmOverrideMutation = mutationFor(clearAlarmOverrideEndpoint);
export const setAlarmSilenceMutation = mutationFor(setAlarmSilenceEndpoint);
